import axios from "axios"
import baseUrl from "./../base"

const skPindahLuarNegeriApi = {
  storeFormSkPindahLuarNegeri: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formSkPindahLuarNegeri/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormSkPindahLuarNegeriKkSama: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formSkPindahLuarNegeri/anggotaKkSama/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormSkPindahLuarNegeriKkSamaByKk: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formSkPindahLuarNegeri/anggotaKkSama/storeByKk`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteFormSkPindahLuarNegeriKkSama: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/formSkPindahLuarNegeri/anggotaKkSama/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormSkPindahLuarNegeriKkBeda: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formSkPindahLuarNegeri/anggotaKkBeda/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteFormSkPindahLuarNegeriKkBeda: async (token, id) => {
    return await axios.post(`${baseUrl}/api/formSkPindahLuarNegeri/anggotaKkBeda/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  cetakFormSkPindahLuarNegeri: async (token, id) => {
    return await axios.get(`${baseUrl}/api/formSkPindahLuarNegeri/${id}/cetak`,
      { headers: { Authorization: `Bearer ${token}` }, responseType: 'arraybuffer' }
    )
  }
}

export default skPindahLuarNegeriApi